/**
 * @module support/one-time-payment
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// Core Libraries
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// Interfaces
import { OneTimePaymentReviewConfigData } from '@experience/one-time-payment/interfaces/one-time-payment.interface';
// Services
import { OneTimePaymentService } from '@experience/one-time-payment/services/one-time-payment.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CartSupportService } from '@support/cart-support/services/cart-support.service';
import { DynamicModal } from '@support/shared/widgets/interfaces/dynamic-modal.interface';

@Component({
  selector: 'tmo-tax-exemption-modal',
  templateUrl: './tax-exemption-modal.component.html',
})
export class TaxExemptionModalComponent implements OnInit, OnDestroy {
  /**
   * Configurable content
   */
  @Input() public aemContent: OneTimePaymentReviewConfigData;

  @Input() public isOrderReview: boolean;
  /**
   * Boolean to store the show and hide modal
   */
  public displayModal: boolean;
  /**
   * Form model for accountForm
   */
  public taxExemptionFormGroup: UntypedFormGroup;
  /**
   * To create the modal
   */
  public modal: DynamicModal;
  /**
   * variable used to emit an event to close modal
   */
  @Output() public closeModal: EventEmitter<boolean>;

  constructor(
    private oneTimePaymentService: OneTimePaymentService,
    private formBuilder: UntypedFormBuilder,
    private cartSupportService: CartSupportService,
    public activatedRoute: ActivatedRoute
  ) {
    this.modal = {
      modalName: 'tax-exemption-modal',
    };
    this.closeModal = new EventEmitter();
  }
  /**
   * Initializes tax exemption modal
   * @returns void
   */
  public ngOnInit(): void {
    this.displayModal = true;
    this.taxExemptionFormGroup = this.formBuilder.group({
      taxExemptionText: ['', Validators.required],
    });
  }
  /**
   * close Tax Exemption Modal
   * @returns void
   */
  public closeTaxExemptionModal(): void {
    this.displayModal = false;
    this.closeModal.emit(this.displayModal);
  }
  /**
   * makes call for API 2606 and exempts tax
   * @returns void
   */
  public saveToOrder(): void {
    this.oneTimePaymentService.taxExemption(this.taxExemptionFormGroup);
    this.displayModal = false;
    this.closeModal.emit(this.displayModal);
  }
  /**
   * makes call to check tax exemption modal display.
   * @returns void
   */
  public exemptTaxOnReviewOrder(): void {
    this.cartSupportService.exemptTaxOnReviewOrder(this.taxExemptionFormGroup);
    this.displayModal = false;
    this.closeModal.emit(this.displayModal);
  }

  /**
   * Method to destroy data.
   * @returns void
   */
  public ngOnDestroy(): void {}
}
